import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { debounce } from "lodash";
import { onBeforeUnmount, ref } from "vue";

interface Props {
  /** two-way bound text state */
  modelValue?: string;
  /** whether field is multi-line */
  multi?: boolean;
  /** delay for debounce in ms */
  debounce?: number;
}

interface Emits {
  /** two-way bound text state */
  (event: "update:modelValue", value: string): void;
  /** when user types in box, after some delay */
  (event: "debounce", value: string): void;
  /** when user "commits" change (pressing enter, blurring, etc) */
  (event: "change", value: string): void;
  /** when input focused */
  (event: "focus"): void;
  /** when input blurred */
  (event: "blur"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppInput',
  props: {
    modelValue: null,
    multi: { type: Boolean },
    debounce: null
  },
  emits: ["update:modelValue", "debounce", "change", "focus", "blur"],
  setup(__props: any, { expose, emit }: { emit: ({
  /** two-way bound text state */
  (event: "update:modelValue", value: string): void;
  /** when user types in box, after some delay */
  (event: "debounce", value: string): void;
  /** when user "commits" change (pressing enter, blurring, etc) */
  (event: "change", value: string): void;
  /** when input focused */
  (event: "focus"): void;
  /** when input blurred */
  (event: "blur"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  /** two-way bound text state */
  modelValue?: string;
  /** whether field is multi-line */
  multi?: boolean;
  /** delay for debounce in ms */
  debounce?: number;
}





/** element reference */
const input = ref();

/** when user focuses box */
function onFocus() {
  onDebounce.cancel();
  emit("focus");
}

/** when user blurs box */
function onBlur() {
  onDebounce.cancel();
  emit("blur");
}

/** when user types in box */
function onInput() {
  emit("update:modelValue", input.value.value);
  onDebounce(input.value.value);
}

/** when user types in box, after some delay */
const onDebounce = debounce(function (value: string) {
  emit("debounce", value);
}, props.debounce || 500);

/** when user "commits" change (pressing enter, blurring, etc) */
async function onChange() {
  onDebounce.cancel();
  emit("change", input.value.value);
}

/** allow parent to access ref */
expose({ input });

/** cancel any pending debounce calls */
onBeforeUnmount(onDebounce.cancel);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.multi ? 'textarea' : 'input'), {
    ref_key: "input",
    ref: input,
    value: __props.modelValue,
    onFocus: onFocus,
    onBlur: onBlur,
    onInput: onInput,
    onChange: onChange
  }, null, 40, ["value"]))
}
}

})